var ezdia;
(function (ezdia) {
    var TEMPLATE = ezdia.templates.queueManagement;
    function showDefaultSysMsg(message) {
        var htmlContent = TEMPLATE.getDefaultSysMsg(message);
        $('#default-sys-message').replaceWith(htmlContent);
    }
    function beforeSelectRow(rowid) {
        var grid = $(this);
        var selrow = grid.jqGrid('getGridParam', 'selrow');
        var returnBool = true;
        if (rowid === selrow) {
            grid.jqGrid('resetSelection');
            $('#queueTaskInfo').empty().hide();
            returnBool = false;
        }
        return returnBool;
    }
    function onSelectRow(ids) {
        var grid = $(this);
        var deselectrow = grid.jqGrid('getGridParam', 'deselectrow');
        if (deselectrow) {
            grid.jqGrid('resetSelection');
            grid.jqGrid('setGridParam', { deselectrow: false });
        }
        else {
            fetchAndShowData(ids);
        }
    }
    function showData(payload) {
        // const template = $.ezdia.template.get('sys-queue-task-details');
        if (payload.experts) {
            payload.experts = payload.experts.split(',');
        }
        var htmlContent = TEMPLATE.queueTaskDetails(payload);
        $('#queueTaskInfo').html(htmlContent);
        $('#queueTaskInfo').show();
    }
    function showErrorData(_a) {
        var _b = _a.message, message = _b === void 0 ? 'Error updating data. Please try again.' : _b;
        var htmlContent = TEMPLATE.queueTaskDetailError(message);
        $('#queueTaskInfo').html(htmlContent);
        $('#queueTaskInfo').show();
    }
    function fetchAndShowData(taskId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, account, role, requestData, response, ex_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = ezdia.config.pageParams, account = _a.account, role = _a.role;
                        requestData = {
                            accountName: account,
                            role: role,
                            taskId: taskId
                        };
                        ezdia.component.grid.loading.show();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, ezdia.Http.post({
                                url: "queueTaskDetails.htm",
                                data: requestData
                            })];
                    case 2:
                        response = _b.sent();
                        showData(response);
                        return [3 /*break*/, 5];
                    case 3:
                        ex_1 = _b.sent();
                        console.error(ex_1);
                        showErrorData(ex_1);
                        return [3 /*break*/, 5];
                    case 4:
                        ezdia.component.grid.loading.hide();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function updateLinkContent(enabel) {
        var htmlContent = TEMPLATE.getActionBtnContent(enabel);
        $(this).html(htmlContent);
        this.dataset.enabel = enabel ? 'false' : 'true';
    }
    function handelRuleAction() {
        return __awaiter(this, void 0, void 0, function () {
            var _a, id, enabel, data, _b, success, message, ex_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.dataset, id = _a.id, enabel = _a.enabel;
                        data = {
                            assignmentQueueId: id,
                            enableRule: true
                        };
                        if (enabel === 'false') {
                            data.enableRule = false;
                        }
                        ezdia.component.grid.loading.show();
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ezdia.Http.post({
                                url: 'enableDisableDefRule.htm',
                                data: data
                            })];
                    case 2:
                        _b = _c.sent(), success = _b.success, message = _b.message;
                        if (success) {
                            ezdia.component.grid.loading.hide();
                            ezdia.util.showSuccessError({
                                message: message
                            });
                            updateLinkContent.call(this, data.enableRule);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        ex_2 = _c.sent();
                        console.error(ex_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function renderDefaultRules() {
        var defaultRules = ezdia.config.pageParams.defaultRules;
        if (!(defaultRules === null || defaultRules === void 0 ? void 0 : defaultRules.length)) {
            return;
        }
        var tabelId = ezdia.util.makeId();
        var htmlContent = TEMPLATE.defaultRulesTable(tabelId, defaultRules);
        $('#default-rule').replaceWith(htmlContent);
        $("#" + tabelId).find("ul a[data-enabel]").on("click", handelRuleAction);
    }
    function renderGrid() {
        var pageParams = ezdia.config.pageParams;
        var tab = pageParams.tab, colModel = pageParams.colModel, colNames = pageParams.colNames, groups = pageParams.groups, rowNum = pageParams.rowNum, account = pageParams.account, role = pageParams.role, requestParam = pageParams.requestParam;
        $.ezdia.config.pageParams.fetchFields = [];
        ezdia.component.grid.create({
            colNames: colNames,
            colModel: colModel,
            groups: groups,
            rowNum: rowNum,
            onSelectRow: onSelectRow,
            beforeSelectRow: beforeSelectRow,
            caption: 'Items',
            id: 'grid',
            url: 'FetchData.htm',
            datatype: 'json',
            mtype: 'POST',
            postData: {
                tab: tab,
                accountName: escape(account),
                role: escape(role),
                orderedFetchFields: function () {
                    return $.ezdia.config.pageParams.fetchFields;
                },
                key: function () {
                    if (!requestParam) {
                        return "";
                    }
                    var reqParam = requestParam;
                    if (typeof requestParam === 'string') {
                        reqParam = ezdia.util.jsonParse(reqParam) || {};
                    }
                    return reqParam.key ? reqParam.key[0] : '';
                }
            },
            onSelectAll: onSelectRow,
            customeBtnsWrapId: 'ez-js-grid-actions-btns',
            hidegrid: false,
            gridview: true
        });
    }
    var QueueManagement = /** @class */ (function () {
        function QueueManagement() {
        }
        QueueManagement.prototype.render = function () {
            ezdia.util.setTitle('Queue management');
            var _a = ezdia.config, message = _a.message, colModel = _a.pageParams.colModel;
            if (message) {
                showDefaultSysMsg(message);
            }
            else {
                renderDefaultRules();
                if (colModel === null || colModel === void 0 ? void 0 : colModel.length) {
                    renderGrid();
                }
            }
            pageLoadingDone();
        };
        return QueueManagement;
    }());
    var pages;
    (function (pages) {
        pages.queueManagement = new QueueManagement();
    })(pages = ezdia.pages || (ezdia.pages = {}));
})(ezdia || (ezdia = {}));
